(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const FF_BTN_BASE = {
    'width': '100%', 'background': '#E6E2D3', 'color': '#000000',
    'border': '1px solid rgba(0,0,0,0.45)', 'border-radius': '6px',
    'padding': '9px 14px', 'font-family': 'Lato,sans-serif',
    'font-size': '9px', 'letter-spacing': '1.5px', 'text-transform': 'uppercase',
    'font-weight': '600', 'display': 'flex', 'align-items': 'center',
    'justify-content': 'center', 'cursor': 'pointer', 'box-sizing': 'border-box'
  };
  const FF_BTN_HOVER = Object.assign({}, FF_BTN_BASE, {
    'background': '#4B6155', 'color': '#fff', 'border': '1px solid #4B6155'
  });

  function ffApplyStyles(el, styles) {
    el.style.cssText = '';
    for (const [p, v] of Object.entries(styles)) {
      el.style.setProperty(p, v, 'important');
    }
  }

  function ffProcessCard(card) {
    const wrap = card.querySelector('.quick-add');
    if (!wrap) return;
    // getBoundingClientRect width is reliable in Shopify editor iframes; window.innerWidth is not
    const isDesktop = card.getBoundingClientRect().width > 250;
    if (!isDesktop) return; // mobile: CSS handles everything, JS does nothing

    // Move button out of gallery to card root (desktop only)
    if (wrap.parentNode !== card) {
      const priceEl = card.querySelector('product-price');
      if (priceEl && priceEl.parentNode === card) {
        card.insertBefore(wrap, priceEl);
      } else {
        card.appendChild(wrap);
      }
    }
    const btn = wrap.querySelector('.quick-add__button, button');
    if (!btn) return;
    ffApplyStyles(btn, FF_BTN_BASE);
    btn.onmouseenter = () => ffApplyStyles(btn, FF_BTN_HOVER);
    btn.onmouseleave = () => ffApplyStyles(btn, FF_BTN_BASE);
  }

  function ffInitButtons() {
    document.querySelectorAll('.product-grid__link').forEach(ffProcessCard);
  }

  // Watch for any new cards added to the DOM (fires immediately — handles editor re-renders)
  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('product-grid__link')) {
          ffProcessCard(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.product-grid__link').forEach(ffProcessCard);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', ffInitButtons);

  // Mobile image dots — update active dot on swipe
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.ff-mc__slides').forEach(function(slider) {
      var dots = slider.closest('.ff-mc__img-wrap') ? slider.closest('.ff-mc__img-wrap').querySelectorAll('.ff-mc__dot') : slider.parentElement ? slider.parentElement.querySelectorAll('.ff-mc__dot') : [];
      if (!dots.length) return;
      slider.addEventListener('scroll', function() {
        var index = Math.round(slider.scrollLeft / slider.offsetWidth);
        dots.forEach(function(d, i) {
          d.classList.toggle('ff-mc__dot--active', i === index);
        });
      }, { passive: true });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function() {
  /* ‚Äö√Æ√Ñ‚Äö√Æ√Ñ Sync cart bubble (count + visibility) ‚Äö√Æ√Ñ‚Äö√Æ√Ñ */
  function ffSyncBubbleOnLoad() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count;
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function(el) {
          el.textContent = count;
        });
        document.querySelectorAll('.cart-bubble__text .visually-hidden').forEach(function(el) {
          el.textContent = 'Total items in cart: ' + count;
        });
        document.querySelectorAll('.cart-bubble').forEach(function(el) {
          if (count > 0) el.classList.remove('visually-hidden');
          else el.classList.add('visually-hidden');
        });
      })
      .catch(function() {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ffSyncBubbleOnLoad);
  } else {
    ffSyncBubbleOnLoad();
  }
  window.addEventListener('pageshow', ffSyncBubbleOnLoad);

  /* ‚Äö√Æ√Ñ‚Äö√Æ√Ñ Intercept all cart-mutating requests so the bubble updates
       whenever ANYTHING changes the cart (add / change / update / clear),
       no matter where the request originates (cart page, drawer, etc.) ‚Äö√Æ√Ñ‚Äö√Æ√Ñ */
  var ffOrigFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(urlStr);
    var p = ffOrigFetch.apply(this, arguments);
    if (isCartMutation) {
      p.then(function() { setTimeout(ffSyncBubbleOnLoad, 50); }).catch(function() {});
    }
    return p;
  };

  /* Also intercept XHR (older form submissions) */
  var ffOrigXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    var urlStr = url || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(urlStr)) {
      this.addEventListener('load', function() { setTimeout(ffSyncBubbleOnLoad, 50); });
    }
    return ffOrigXhrOpen.apply(this, arguments);
  };

  /* ‚Äö√Æ√Ñ‚Äö√Æ√Ñ Ensure qty + ATC sit in a flex row on desktop, even when the
       theme doesn't wrap them in buy-buttons-component ‚Äö√Æ√Ñ‚Äö√Æ√Ñ */
  function ffWrapBuyRow() {
    if (window.innerWidth < 750) return;
    var qty = document.querySelector('quantity-selector-component');
    var btn = document.querySelector('.main-add-to-cart__button, .add-to-cart-button, button[name="add"]');
    if (!qty || !btn) return;
    if (qty.closest('buy-buttons-component, .product-form__buttons, .buy-buttons, .ff-buy-row')) return;
    if (qty.parentElement !== btn.parentElement) return;
    var parent = qty.parentElement;
    var row = document.createElement('div');
    row.className = 'ff-buy-row';
    parent.insertBefore(row, qty);
    row.appendChild(qty);
    row.appendChild(btn);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ffWrapBuyRow);
  } else {
    ffWrapBuyRow();
  }

  /* ‚Äö√Æ√Ñ‚Äö√Æ√Ñ Custom Add-to-Cart handler ‚Äö√Æ√Ñ‚Äö√Æ√Ñ
     The theme's product-form-component handler is silently broken (shows
     "Added" text but never fires /cart/add). We intercept the click,
     fetch /cart/add.js ourselves, then update the cart bubble + button. */

  function ffUpdateCartBubble() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count;
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function(el) {
          el.textContent = count;
        });
        document.querySelectorAll('.cart-bubble__text .visually-hidden').forEach(function(el) {
          el.textContent = 'Total items in cart: ' + count;
        });
        document.querySelectorAll('.cart-bubble').forEach(function(el) {
          if (count > 0) el.classList.remove('visually-hidden');
          else el.classList.add('visually-hidden');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function() {});
  }

  function ffSetButtonAdded(btn) {
    var label = btn.querySelector('.add-to-cart-text__content, .add-to-cart-text');
    var orig = btn.dataset.ffOrigText;
    if (!orig) {
      btn.dataset.ffOrigText = (label ? label.textContent : btn.textContent).trim();
    }
    if (label) label.textContent = 'Added!';
    else btn.textContent = 'Added!';
    setTimeout(function() {
      if (label) label.textContent = btn.dataset.ffOrigText || 'Add to Cart';
      else btn.textContent = btn.dataset.ffOrigText || 'Add to Cart';
    }, 1800);
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.main-add-to-cart__button, .add-to-cart-button, button[name="add"]');
    if (!btn) return;
    if (btn.disabled) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    /* Block the theme handler entirely */
    e.preventDefault();
    e.stopImmediatePropagation();

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: idInput.value, quantity: qty }] })
    })
      .then(function(r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function() {
        ffUpdateCartBubble();
        ffSetButtonAdded(btn);
      })
      .catch(function() {
        var label = btn.querySelector('.add-to-cart-text__content, .add-to-cart-text');
        if (label) label.textContent = 'Try again';
        else btn.textContent = 'Try again';
      })
      .finally(function() {
        setTimeout(function() { btn.disabled = false; }, 600);
      });
  }, true);

  function buildCard() {
    if (window.innerWidth > 749) return;
    if (document.querySelector('.ff-atc-card')) return;

    var qty = document.querySelector('quantity-selector-component');
    if (!qty) return;

    var priceEl = document.querySelector('product-price');

    /* Stack qty + button vertically */
    var parent = qty.parentElement;
    parent.style.cssText += 'display:flex!important;flex-direction:column!important;gap:10px!important;width:100%!important;';

    if (!priceEl) return;

    /* Build side-by-side card */
    var card = document.createElement('div');
    card.className = 'ff-atc-card';
    card.style.cssText = 'display:flex;align-items:center;background:rgba(0,0,0,0.04);border-radius:10px;overflow:hidden;width:100%;box-sizing:border-box;height:76px;';

    var left = document.createElement('div');
    left.style.cssText = 'flex:1;padding:8px 14px;border-right:1px solid rgba(0,0,0,0.08);display:flex;flex-direction:column;justify-content:center;overflow:hidden;height:76px;';
    var lbl1 = document.createElement('div');
    lbl1.style.cssText = 'font-size:8px;letter-spacing:1.5px;color:#aaa;text-transform:uppercase;font-family:Lato,sans-serif;margin-bottom:4px;';
    lbl1.textContent = 'Price';
    left.appendChild(lbl1);
    left.appendChild(priceEl);

    var right = document.createElement('div');
    right.style.cssText = 'flex:1;padding:28px 14px 8px;display:flex;flex-direction:column;justify-content:flex-start;gap:3px;height:76px;overflow:hidden;';
    right.appendChild(qty);

    card.appendChild(left);
    card.appendChild(right);
    parent.insertBefore(card, parent.firstChild);
  }

  /* ‚Äö√Æ√Ñ‚Äö√Æ√Ñ Centered toast ‚Äö√Æ√Ñ‚Äö√Æ√Ñ */
  function showStockToast(msg) {
    var t = document.getElementById('ff-pp-stock-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ff-pp-stock-toast';
      t.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) scale(0.9);background:#1a1a1a;color:#fff;padding:14px 22px;border-radius:10px;font-family:Lato,sans-serif;font-size:13px;font-weight:600;letter-spacing:0.5px;z-index:10000;opacity:0;transition:opacity 0.25s,transform 0.25s;pointer-events:none;box-shadow:0 8px 32px rgba(0,0,0,0.4);text-align:center;max-width:80vw;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function() {
      t.style.opacity = '1';
      t.style.transform = 'translate(-50%,-50%) scale(1)';
    });
    clearTimeout(t._hide);
    t._hide = setTimeout(function() {
      t.style.opacity = '0';
      t.style.transform = 'translate(-50%,-50%) scale(0.9)';
    }, 2200);
  }

  /* ‚Äö√Æ√Ñ‚Äö√Æ√Ñ Sync qty selector max from cart ‚Äö√Æ√Ñ‚Äö√Æ√Ñ */
  function getVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input) return input.value;
    var urlVariant = new URL(window.location.href).searchParams.get('variant');
    return urlVariant;
  }

  function syncMaxFromCart() {
    var qtyInput = document.querySelector('quantity-selector-component [data-quantity-input]');
    if (!qtyInput) return;
    var stockTotal = parseInt(qtyInput.dataset.inventory, 10);
    if (isNaN(stockTotal)) return;
    var variantId = getVariantId();
    if (!variantId) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var inCart = 0;
        cart.items.forEach(function(it) {
          if (String(it.variant_id) === String(variantId)) inCart += it.quantity;
        });
        var remaining = Math.max(stockTotal - inCart, 0);
        qtyInput.dataset.stockTotal = stockTotal;
        qtyInput.dataset.inCart = inCart;
        /* Only adjust max if inventory is tracked and finite */
        if (stockTotal > 0) {
          qtyInput.max = remaining;
        }
        /* Clamp current value */
        var current = parseInt(qtyInput.value, 10) || 1;
        if (current > remaining) {
          qtyInput.value = Math.max(remaining, 1);
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Style ATC button when nothing more can be added */
        var atcBtn = document.querySelector('button[name="add"], .add-to-cart-button, .main-add-to-cart__button');
        if (!atcBtn) return;
        if (remaining === 0 && stockTotal > 0) {
          atcBtn.disabled = true;
          atcBtn.style.background = '#656E5A';
          atcBtn.style.backgroundColor = '#656E5A';
          atcBtn.style.color = '#fff';
          atcBtn.style.opacity = '0.75';
          atcBtn.style.cursor = 'not-allowed';
          var label = atcBtn.querySelector('.add-to-cart-text__content, .add-to-cart-text > span:not(.svg-wrapper), span:not(.svg-wrapper):not(.add-to-cart-icon)');
          if (label) {
            label.textContent = inCart > 0 ? 'Max in Cart' : 'Sold Out';
            label.style.color = '#fff';
            label.style.opacity = '1';
          } else {
            atcBtn.textContent = inCart > 0 ? 'Max in Cart' : 'Sold Out';
          }
          qtyInput.disabled = true;
          var incBtn = document.querySelector('[data-quantity-increase]');
          var decBtn = document.querySelector('[data-quantity-decrease]');
          if (incBtn) incBtn.disabled = true;
          if (decBtn) decBtn.disabled = true;
        }
      })
      .catch(function() {});
  }

  /* ‚Äö√Æ√Ñ‚Äö√Æ√Ñ Capture + clicks to show toast AND block increment when at max ‚Äö√Æ√Ñ‚Äö√Æ√Ñ */
  function onIncreaseClick(e) {
    var inc = e.target.closest('[data-quantity-increase]');
    if (!inc) return;
    var wrap = inc.closest('quantity-selector-component');
    if (!wrap) return;
    var qtyInput = wrap.querySelector('[data-quantity-input]');
    if (!qtyInput) return;
    var max = parseInt(qtyInput.max, 10);
    var stockTotal = parseInt(qtyInput.dataset.stockTotal || qtyInput.dataset.inventory, 10);
    var inCart = parseInt(qtyInput.dataset.inCart || '0', 10);
    var current = parseInt(qtyInput.value, 10) || 1;

    /* Sold out / nothing more allowed ‚Äö√ú√≠ block + toast */
    if (!isNaN(max) && max <= 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (stockTotal === 0) showStockToast('Sold out');
      else showStockToast('All ' + stockTotal + ' already in your cart');
      return;
    }

    /* At cap (works for stock=1 case too where max=1, current=1) */
    if (!isNaN(max) && current >= max) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (inCart > 0) {
        showStockToast('Only ' + max + ' more available (' + inCart + ' already in cart)');
      } else if (!isNaN(stockTotal) && stockTotal > 0) {
        showStockToast('Only ' + stockTotal + ' available ‚Äö√Ñ√Æ that\'s all we have');
      } else {
        showStockToast('Only ' + max + ' left in stock');
      }
      return;
    }

    /* Fallback: max attr not set but qty selector still won't go up
       (e.g. theme enforces stock natively). Show a generic toast. */
    if (!isNaN(stockTotal) && stockTotal > 0 && current >= stockTotal) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showStockToast('Only ' + stockTotal + ' available ‚Äö√Ñ√Æ that\'s all we have');
    }
  }

  function init() {
    buildCard();
    syncMaxFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', onIncreaseClick, true);

  /* Refresh after add-to-cart succeeds */
  document.addEventListener('cart:updated', syncMaxFromCart);
  /* Refresh when variant changes (Shopify dispatches variant:update or similar) */
  document.addEventListener('variant:update', function() {
    setTimeout(syncMaxFromCart, 100);
  });
  /* Refresh when user comes back via back button */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) syncMaxFromCart();
  });
})();



  } catch(e) { console.error(e); }
})();
})();
